import { z } from 'zod'
import { Result } from '@cplug/frontend-core/utils'
import { factoryListDTOWithOptionalMeta, type DTODataListWithOptionalMeta } from '@cplug/frontend-core/gateways'
import type { PageList } from '@cplug/frontend-core/models'
import { type AppGroup } from '../models/AppGroup'
import { mapDTOToAppGroup, AppGroupDTO } from './DTOs/AppGroupDTO'
import { CPBaseListPaginatedGateway } from '~/shared/gateways/CPBaseListPaginatedGateway'

const ListDTOSchema = z.object({ sources: AppGroupDTO.array() })
type ListDTO = { sources: AppGroupDTO[] }

export class CPAppGroupGateway extends CPBaseListPaginatedGateway<AppGroup, AppGroupDTO, ListDTO> {
  protected listField: keyof ListDTO = 'sources'

  protected dtoToModelMapper = (dto: AppGroupDTO): Result<AppGroup> => Result.ofValue(mapDTOToAppGroup(dto))

  private get listSchemaWithoutMeta (): z.ZodType<DTODataListWithOptionalMeta<ListDTO>> {
    return factoryListDTOWithOptionalMeta(ListDTOSchema) as unknown as z.ZodType<DTODataListWithOptionalMeta<ListDTO>>
  }

  async listAll (): Promise<Result<PageList<AppGroup>>> {
    const response = await this.get('apps/grouped-by-source')

    return this.parseResponse(response, this.listSchemaWithoutMeta, this.listDtoToModelPageListMapper.bind(this))
  }
}
